import { render } from "./capitalList.vue?vue&type=template&id=1ed5b7f7"
import script from "./capitalList.vue?vue&type=script&lang=js"
export * from "./capitalList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__